// extracted by mini-css-extract-plugin
export var currencyInput = "_m0-1";
export var currencySymbol = "_m0-0";